import { FunctionComponent, h, VNode, PreactDOMAttributes } from 'preact';
import { StyledButton } from './button.styles';

export interface ButtonProps extends PreactDOMAttributes {
  onClick?: () => void;
  onBlur?: () => void;
  type?: 'button' | 'gradient' | 'reset';
  className?: string;
  disabled?: boolean;
  children?: string | VNode | VNode[];
}

const Button: FunctionComponent<ButtonProps> = ({
  onClick,
  onBlur,
  type = 'button',
  className = '',
  disabled = false,
  children,
  ...otherProps
}) => {
  return (
    <StyledButton
      type={type}
      className={className}
      onClick={onClick}
      onBlur={onBlur}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
